import { useVideoExportContext } from "@/animation/video-generator/components/VideoExportContext";
import { useOverlay } from "@/overlay/overlays/default/ViewportOverlayProvider";
import { useMemo } from "react";

export function useExportStatus() {
  const { isVideoRecordingActive } = useVideoExportContext();
  const { processingImage } = useOverlay();

  const isExportActive = useMemo(
    () => isVideoRecordingActive || processingImage,
    [isVideoRecordingActive, processingImage],
  );

  const kind = useMemo(() => {
    if (isVideoRecordingActive) {
      return "video";
    }
    if (processingImage) {
      return "image";
    }
    return "none";
  }, [isVideoRecordingActive, processingImage]);

  return {
    isExportActive,
    isVideoExportActive: kind === "video",
    isImageExportActive: kind === "image",
  };
}
